module.exports = __webpack_public_path__ + "static/media/contractOfLand.d624c09e.jpg";